module.exports = __webpack_public_path__ + "img/icon-group8.ff315394.png";